import {Component, OnInit} from '@angular/core';
import {BlockStatementAbstractComponent} from '../block-statement-abstract.component';
import {MaximiseReward} from '../../types/maximise.reward.type';

@Component({
    selector: 'core-calls-to-action',
    templateUrl: './block-maximise-rewards.component.html',
    standalone: false
})
export class BlockMaximiseRewardsComponent extends BlockStatementAbstractComponent implements OnInit {
    maximiseRewards!: MaximiseReward[];
    isBlankPageNeededForPdf!: boolean;

    override ngOnInit(): void {
        super.ngOnInit();
        this.maximiseRewards = this.trsService.getUserMaximiseRewards();
        this.isBlankPageNeededForPdf = this.trsService.showPdfBlankPage1();
    }

}
